module.exports = __webpack_public_path__ + "static/img/success.190c9be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/success.svg
// module id = l2Wo
// module chunks = 69